import { render, staticRenderFns } from "./UpdateRetentionForm.vue?vue&type=template&id=3348ed5f&"
import script from "./UpdateRetentionForm.vue?vue&type=script&lang=js&"
export * from "./UpdateRetentionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports